import { connect } from 'react-redux'
import AssignmentsComponent from '../../components/openforwork/assignments.component'
import {
  getFieldOfWork,
  getAllAssignments,
  applyAssignment,
  cancelApplyAssignment,
  loadOpenForWorkStart,
  searchAssignment,
  loadProfileStart,
  sendApplication,
  closeSuccessSendApplication,
  trackApplication,
  getAreaOfWork,
  updateViewAssignment,
  pinAssignment,
  getApplicationProfile,
  getBillableHourUser,
  getAssignmentOfferToEmail
} from '../../actions'
import store from '../../store'
import { convertDataToDict } from '../../utils/showIndustry.utils'
import { groupWorkshiftByCompany } from './workshiftNormalUser.container'
import {
  getCompanyRatings,
  mergeAssignments,
  updateStatusData
} from '../../utils/openForWork.utils'

const mapStateToProps = (state) => {
  const directlyOfferedAssignmentId = new Set(
    state.assignment.directlyOfferedAssignmentId
  ) // Directly offered contract to assignment
  const loggedMail = store.getState().client.user.data[1]
  const assignmentRows = state.assignment.assignmentRows.filter(
    (item) => !directlyOfferedAssignmentId?.has(item?.assignment_id)
  )
  // const loggedMail = store.getState().client.user.data[1]
  // const assignmentRows = state.assignment.assignmentRows
  const appliedAssignmentId = state.assignment.appliedAssignmentId
  const searchAssignmentStatus = state.assignment.searchAssignmentStatus
  // Filter assignements because it includes assignment that offered directly to email
  // If that assignment is offered to other email that is different with loggin => remove that assignment from lists
  let user_area_of_work = []
  if (state.openForWork.applicationData?.AreaOf_Work) {
    user_area_of_work = state.openForWork.applicationData.AreaOf_Work
  }
  // Assignments that offfer to specific industry
  // const filterAssignmentRows = assignmentRows.filter(
  //   (el) =>
  //     (el.enterpreneur_email === 'placeholder' ||
  //       el.enterpreneur_email === null) &&
  //     // Check the item in industry that appear at user area of work
  //     el.industry_type
  //       .split(',')
  //       .some((item) => user_area_of_work.includes(Number(item))) &&
  //     new Date(el.last_date_of_application).setHours(0, 0, 0, 0) >=
  //       new Date().setHours(0, 0, 0, 0)
  // )

  // This merged data is all assignments, and assignments that applied
  const mergedAssignmentRows = mergeAssignments(
    assignmentRows,
    state.assignment.appliedData
  )

  const updatedAssignmentRows = updateStatusData(
    mergedAssignmentRows,
    appliedAssignmentId,
    loggedMail,
    user_area_of_work
  ).filter((el) => el.status !== 3) // Applied assignment

  const filteredAssignmentRows =
    searchAssignmentStatus !== 0
      ? updatedAssignmentRows.filter(
          (assignment) => assignment.status === searchAssignmentStatus
        )
      : updatedAssignmentRows

  const assignmentsByCompany = groupAssignmentByCompany(filteredAssignmentRows)
  // console.log(
  //   'huong assignmentsByCompany >>>>>>>>>>>>>>>>>>>>>>>>>',
  //   assignmentsByCompany
  // )
  // Recommended assignment
  // const recommendedAssignment = assignmentRows.filter(
  //   (el) =>
  //     (el.enterpreneur_email === loggedMail ||
  //       (el?.enterpreneur_email &&
  //         el.enterpreneur_email.includes(loggedMail))) &&
  //     new Date(el.last_date_of_application).setHours(0, 0, 0, 0) >=
  //       new Date().setHours(0, 0, 0, 0)
  // )
  const assignmentPageSize = state.assignment.assignmentPageSize
  const areaOfWorkDict = convertDataToDict(state.openForWork.areaOfWorkList)

  const billableHourUser = groupWorkshiftByCompany(
    state.workShiftUser.billableHourUserRow
  )
  const companyRatings = getCompanyRatings(billableHourUser)
  return {
    state,
    fieldOfWork: state.profile.fieldOfWork,
    assignmentRows: assignmentsByCompany,
    filteredAssignmentRows: filteredAssignmentRows,
    appliedData: state.assignment.appliedData,
    showApplyForm: state.assignment.showApplyForm,
    // workProfileData: state.openForWork.applicationData,
    assignmentPageSize: assignmentPageSize,
    userData: state.profile.userData,
    // profileData: state.profile.userData,
    applySuccess: state.assignment.applySuccess,
    // recommendedAssignment: recommendedAssignment,
    areaOfWorkDict: areaOfWorkDict,
    areaOfWorkList: state.openForWork.areaOfWorkList,
    isSearchAssignmentSuccess: state.assignment.isSearchAssignmentSuccess,
    appliedData_search: state.assignment.appliedData_search,
    openForWorkFormValues: state.form.openforwork?.loadData,
    applicationProfileData: state.application.applicationProfileData[0],
    ratingsByCompany: companyRatings.result,
    ratingsSummary: companyRatings.summary
  }
}

// Group assignments by company
export const groupAssignmentByCompany = (assignments) => {
  return Object.values(
    assignments.reduce((acc, assignment) => {
      const key = assignment.company_name
      if (!acc[key]) {
        acc[key] = {
          company_name: assignment.company_name,
          assignments: []
        }
      }
      acc[key].assignments.push(assignment)
      return acc
    }, {})
  )
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getFieldOfWork: () => dispatch(getFieldOfWork()),
    trackApplication: () => dispatch(trackApplication()),
    getAllAssignments: () => dispatch(getAllAssignments()),
    applyAssignment: (job) => dispatch(applyAssignment(job)),
    cancelApplyAssignment: () => dispatch(cancelApplyAssignment()),
    loadOpenForWorkStart: () => dispatch(loadOpenForWorkStart()),
    searchAssignment: (values) => dispatch(searchAssignment(values)),
    loadProfileStart: () => dispatch(loadProfileStart()),
    sendApplication: (job_info, ratingData) =>
      dispatch(sendApplication(job_info, ratingData)),
    closeSuccessSendApplication: () => dispatch(closeSuccessSendApplication()),
    getAreaOfWork: () => dispatch(getAreaOfWork()),
    updateViewAssignment: (assignment_id, uuid) =>
      dispatch(updateViewAssignment(assignment_id, uuid)),
    pinAssignment: (assignment_id) => dispatch(pinAssignment(assignment_id)),
    getApplicationProfile: (values) => dispatch(getApplicationProfile(values)),
    getBillableHourUser: () => dispatch(getBillableHourUser()),
    getAssignmentOfferToEmail: () => dispatch(getAssignmentOfferToEmail())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const AssignmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AssignmentsComponent)

export default AssignmentsContainer
